import React from "react";
import { Button, Nav, NavItem, Navbar } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";

import { login, logout, authConfig } from "../actions/meta";
import hotLogo from "../images/hot-logo.svg";
import { selectIsLoggedIn } from "../selectors";
import LocaleSelector from "./LocaleSelector";
import RequirePermission from "./RequirePermission";
import HankoAuthButton from "./HankoAuthButton";
import ToolMenu from "./ToolMenu";

const collapseNavbar = (e) => {
  if (e.target.closest && e.target.closest(".dropdown-toggle")) return;
  if (e.target.tagName && e.target.tagName.toLowerCase() === "hotosm-auth") return;
  const toggle = document.querySelector(".navbar-toggle");
  const collapse = document.querySelector(".navbar-collapse");
  if (toggle && collapse && collapse.classList.contains("in")) {
    toggle.click();
  }
};

const NavBar = ({ isLoggedIn, login, logout, locale }) => (
  <Navbar>
    <Navbar.Header>
      <Navbar.Brand>
        <Link to="/exports/new">
          <img className="logo" src={hotLogo} role="presentation" />
          <span>Export Tool</span>
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>
    <Navbar.Collapse onClick={collapseNavbar}>
    <Nav className="pull-right">
      <RequirePermission>
        <li>
          <NavLink to="/exports/new">
            <FormattedMessage id="ui.create" defaultMessage="Create" />
          </NavLink>
        </li>
      </RequirePermission>
      <li>
        <NavLink to="/exports" exact>
          <FormattedMessage id="ui.exports" defaultMessage="Exports" />
        </NavLink>
      </li>
      <li>
        <NavLink to="/configurations">
          <FormattedMessage id="ui.configurations" defaultMessage="Configs" />
        </NavLink>
      </li>
      <RequirePermission
        required={[
          "jobs.add_partnerexportregion",
          "jobs.change_partnerexportregion",
          "jobs.delete_partnerexportregion",
        ]}
      >
        <li>
          <NavLink to="/partners">
            <FormattedMessage id="ui.partners" defaultMessage="Partners" />
          </NavLink>
        </li>
      </RequirePermission>
      <RequirePermission
        required={[
          "jobs.add_hdxexportregion",
          "jobs.change_hdxexportregion",
          "jobs.delete_hdxexportregion",
        ]}
      >
        <li>
          <NavLink to="/hdx">
            <FormattedMessage id="ui.hdx" defaultMessage="HDX" />
          </NavLink>
        </li>
      </RequirePermission>
      <RequirePermission required={["auth.add_user"]}>
        <li>
          <a href="/admin">
            <FormattedMessage id="ui.admin" defaultMessage="Admin" />
          </a>
        </li>
      </RequirePermission>
      <RequirePermission required={["auth.add_user"]}>
        <li>
          <a href="/worker-dashboard/" target="_blank">
            <FormattedMessage id="ui.workers" defaultMessage="Workers" />
          </a>
        </li>

      </RequirePermission>
      <RequirePermission required={["auth.add_user"]}>
        <li>
          <a href="/api/status" target="_blank">
            <FormattedMessage id="ui.machine_status" defaultMessage="Status" />
          </a>
        </li>

      </RequirePermission>
      <RequirePermission required={["auth.add_user"]}>
        <li>
          <NavLink to="/stats">
            <FormattedMessage id="ui.stats" defaultMessage="Stats" />
          </NavLink>
        </li>
      </RequirePermission>
      <li>
        <NavLink to="/">
          <FormattedMessage id="ui.about" defaultMessage="About" />
        </NavLink>
      </li>
      <li>
        <NavLink to="/learn">
          <FormattedMessage id="ui.help" defaultMessage="Learn" />
        </NavLink>
      </li>
      <li>
        <a
          href="https://roadmap.hotosm.org/#tech-request"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span title="For technical support click here">
            <FormattedMessage id="ui.support" defaultMessage="Support" />
          </span>
        </a>
      </li>
      <NavItem>
        <LocaleSelector />
      </NavItem>
      {authConfig.isHankoAuth ? (
        <li>
          <a className="hotosm-auth">
            <HankoAuthButton
              hankoUrl={authConfig.hankoUrl}
              redirectAfterLogin={window.location.origin + "/v3/"}
              mappingCheckUrl={window.location.origin + "/api/v1/auth/status/"}
              appId="osm-export-tool"
              button-variant="filled"
              button-color="danger"
              lang={locale}
            />
          </a>
        </li>
      ) : null}
      <li>
        <a className="hotosm-tool-menu">
          <ToolMenu lang={locale} />
        </a>
      </li>
      {!authConfig.isHankoAuth && (
        <NavItem>
          {!isLoggedIn && (
            <Button bsStyle="danger" onClick={login}>
              <FormattedMessage id="ui.log_in" defaultMessage="Log In" />
            </Button>
          )}
          {isLoggedIn && (
            <Button bsStyle="danger" onClick={logout}>
              <FormattedMessage id="ui.log_out" defaultMessage="Log Out" />
            </Button>
          )}
        </NavItem>
      )}
    </Nav>
    </Navbar.Collapse>
  </Navbar>
);

const mapStateToProps = (state) => ({
  isLoggedIn: selectIsLoggedIn(state),
  locale: state.intl.locale,
});

export default connect(mapStateToProps, { login, logout })(NavBar);



// WEBPACK FOOTER //
// ./app/components/NavBar.js